<template>
  <div class="identity-verification">
    <!-- 详情头 -->
    <a-space align="center">
      <a-icon type="left" style="font-size: 23px" @click="changeToInfoDetail" />
      <div
        class="ant-descriptions-title"
        style="font-size: 16px; margin-bottom: 0px"
      >
        企业认证
      </div>
    </a-space>

    <!-- 步骤条 -->
    <a-steps
      :current="currentStep"
      style="margin-bottom: 30px; margin-top: 20px"
    >
      <a-step title="上传营业执照" />
      <a-step title="提交完成" />
    </a-steps>

    <div v-show="currentStep === 0" style="margin-top: 40px">
      <BusinessLicense ref="businessLicenseRef"></BusinessLicense>
      <div class="action-buttons">
        <a-button @click="updateBusinessLicense" type="primary" size="large" :loading="state.buttonLoading"
          >提交</a-button
        >
      </div>
    </div>

    <div v-if="currentStep === 1">
      <a-result
        status="info"
        title="企业认证审核中"
        sub-title="您的企业认证信息已提交成功，目前正在进行人工审核，请耐心等待审核结果。审核通过后，您可返回业务页面继续后续操作"
      >
        <template #extra>
          <a-button @click="changeToInfoDetail">返回</a-button>
        </template>
      </a-result>
    </div>
  </div>
</template>

<script>
import BusinessLicense from "./verifyInfo/BusinessLicense";
import { updateCompany } from "@/api/company/Company.js";
export default {
  components: {
    BusinessLicense,
  },
  data() {
    return {
      state:{
        buttonLoading:false,
      },
      currentStep: 0, // 当前步骤
      businessLicenseFormData: {},
    };
  },
  methods: {
    changeToInfoDetail() {
      console.log;
      this.$emit("changeToInfoDetail");
    },

    async updateBusinessLicense() {
      const res = await this.$refs.businessLicenseRef.validateForNextStep();

      if (!res.valid) return;
      this.state.buttonLoading = true;
      this.businessLicenseFormData = res.data;

      const businessLicenseFiles = this.businessLicenseFormData.businessLicense.map(
        (item) => ({
          fileName: item.name,
          fileUrl: item.url,
        })
      );

      //更新营业执照表
      updateCompany({
            ...this.businessLicenseFormData,
            businessLicenseFiles,
          })
            //登入失败在这里改动
            .then((res) => this.createSuccess(res))
            .catch((err) => this.requestFailed(err))
            .finally(() => {});
    },

     createSuccess(res) {
      if (res.code == "200") {
        setTimeout(() => {
          this.$notification.success({
            message: `提交成功`,
            description: `营业执照更新已提交，请等待审核`,
          });
          this.state.buttonLoading = false;
          this.currentStep++;
        }, 500);
      } else {
        setTimeout(() => {
          this.state.buttonLoading = false;
          this.$notification["error"]({
            message: "错误",
            description: res.msg,
          });
        }, 500);
      }
    },
    //服务器报错时发生
    requestFailed(err) {
      setTimeout(() => {
        this.state.buttonLoading = false;
        this.$notification["error"]({
          message: "错误",
          description:
            ((err.response || {}).data || {}).message || "网络异常，请稍后再试",
          duration: 4,
        });
      }, 500);
    },
  },
};
</script>

<style scoped>
.identity-verification {
  padding: 20px;
}

.verification-content {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.qr-section {
  text-align: center;
}

.left-section {
  width: 48%;
}

.right-section {
  width: 48%;
}

.vertical-divider {
  width: 1px;
  background-color: #e8e8e8;
  margin: 0 20px;
}

.upload-item {
  margin-bottom: 20px;
  margin-top: 10px;
}

.upload-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.upload-icon {
  font-size: 24px;
  color: #1890ff;
  margin-right: 10px;
}

.upload-btn {
  margin-top: 10px;
}

.personal-info {
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 5px;
}

.info-item {
  display: flex;
  margin-bottom: 24px;
}

.label {
  font-weight: bold;
  margin-right: 10px;
}

.error-msg {
  color: red;
  font-size: 12px;
}

.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 20px;
}

/* 输入框高度统一 */
.right-section /deep/ input.ant-input {
  height: 32px !important;
  border-radius: 4px;
}
</style>
